module.exports = __webpack_public_path__ + "media/images/advisers/img_ishi-50220721547310c06e23562129627b99.jpg";